export default __webpack_public_path__ + "static/directrice-1bd4832347d64721681164041e536cf8.png";